export const iconFontAwesomeGamingSkullCrossbones = (
	<i className="fa-solid fa-skull-crossbones"></i>
);
